import React from "react";
import { List } from "../modules/PlatformResultsReview";

export function PlatformResultsReview() {
  return <List />;
}
